import { render, staticRenderFns } from "./SnsContentSection.vue?vue&type=template&id=03825304&scoped=true"
import script from "./SnsContentSection.vue?vue&type=script&lang=ts"
export * from "./SnsContentSection.vue?vue&type=script&lang=ts"
import style0 from "./SnsContentSection.vue?vue&type=style&index=0&id=03825304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03825304",
  null
  
)

export default component.exports